import React from 'react';
import { Box, Button } from '@mui/material';

import Modal from '../../../ui/Modal';

const ConfirmationModal = ({ bidderName, isOpen, onClose }) => (
  <Modal
    isOpen={isOpen}
    toggle={onClose}
  >
    <Modal.Header toggle={onClose}>{`Send message to ${bidderName}`}</Modal.Header>
    <Modal.Body>
      <Box>
        <p>Message Sent</p>
      </Box>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose} color="primary" variant="contained">
        Close Window
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmationModal;
